import { createContext } from "react";

const blogsContext = createContext();

export default blogsContext;